import { api } from "./api";

export const listByBriefingId = async (briefingId: number) => {
    return api.get(`/component/listComponentByBriefing/${briefingId}`)
}

export const createComponent = async (briefingId: number, data: any) => {
    return api.post(`/component/create/${briefingId}`, data)
}

export const deleteFileComponentByComponentId = async (componentId: number) => {
    return api.delete(`/component/deleteComponentImageByComponent/${componentId}`)
}

export const deleteComponent = async (componentId: number) => {
    return api.delete(`/component/delete/${componentId}`)
}

export const updateComponent = async (componentId: number, data: any) => {
    return api.patch(`/component/updateComponent/${componentId}`, data)
}

export const updatePositionComponent = async (data: any) => {
    return await api.patch('/component/updateComponentPosition', data);
}

export const uploadFile = async (componentId: number, attendanceId: number, clientId: number, data: any) => {
    return api.post(`/componentImage/post/${clientId}/${attendanceId}/${componentId}`, data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const uploadProjetoTecnico = async (attendanceId: number, data: any) => {
    return api.post(`/componentImage/projetoTecnico/${attendanceId}`, data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const buscarArquivoProjetoTecnico = async (attendanceId: number) => {
    return api.get(`/componentImage/buscarArquivoProjetoTecnico/${attendanceId}`)
}

export const listComponentFileByComponentId = async (componentId: number) => {
    return api.get(`/componentImage/listComponentImage/${componentId}`)
}

export const deleteFile = async (idImage: number) => {
    return api.delete(`componentImage/deleteComponentImage/${idImage}`)
}

const componentApi = {
    listByBriefingId,
    createComponent,
    deleteFileComponentByComponentId,
    deleteComponent,
    updateComponent,
    updatePositionComponent,
    uploadFile,
    uploadProjetoTecnico,
    listComponentFileByComponentId,
    deleteFile
}

export default componentApi;